"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _spinner = _interopRequireDefault(require("../spinner"));

var _ = require("../..");

var _metrics = require("../../_helpers/metrics");

var _bind = _interopRequireDefault(require("classnames/bind"));

var _mobxReact = require("mobx-react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require("./Button.css");

var _styles = {
  "btn": "Button__btn___1rpIP",
  "small": "Button__small___1hZw5",
  "selected": "Button__selected___1XfgI",
  "surveySelectedVariant": "Button__surveySelectedVariant___2L8YV",
  "tooltip": "Button__tooltip___3-c59",
  "top": "Button__top___1RgJd",
  "spinner": "Button__spinner___1Zr-w",
  "contained": "Button__contained___2q5ys",
  "disabled": "Button__disabled___1KB9j",
  "loading": "Button__loading___3gbsc",
  "success": "Button__success___3v-_z",
  "error": "Button__error___2fOhL",
  "warning": "Button__warning___1m7gp",
  "outlined": "Button__outlined___2MV60",
  "tertiary": "Button__tertiary___3iVbd",
  "inline": "Button__inline___1efrI",
  "outlined-gray": "Button__outlined-gray___cf_Ss"
};

const styles = _bind.default.bind(_styles);

const isLink = onClick => {
  return 'location' in onClick;
};

const isInternalLink = onClick => {
  return 'location' in onClick && 'component' in onClick;
};

const Button = (0, _mobxReact.observer)(({
  className,
  disabled,
  label,
  small,
  variant,
  loading,
  onClick,
  dataTestId,
  selected,
  surveySelectedVariant,
  tooltipMessage,
  tooltipPosition = 'bottom',
  flexAlignSelf,
  type,
  ...props
}) => {
  const composed_classname = (0, _bind.default)(styles('btn', variant, type, {
    small,
    loading,
    disabled,
    surveySelectedVariant,
    selected: !surveySelectedVariant && selected
  }), className);
  const composed_styles = {
    alignSelf: flexAlignSelf
  };

  if (!isLink(onClick)) {
    return _react.default.createElement("button", {
      type: 'button',
      "aria-label": typeof label === 'string' ? label : 'Button',
      className: composed_classname,
      onClick: e => {
        if (dataTestId) {
          (0, _metrics.trackAction)(`click on ${dataTestId}`);
        }

        onClick(e);
      },
      disabled: !!disabled || !!loading,
      "data-testid": dataTestId,
      style: composed_styles,
      ...props
    }, label, loading && _react.default.createElement(_spinner.default, {
      size: 'small',
      className: styles('spinner')
    }), tooltipMessage && _react.default.createElement("div", {
      className: (0, _bind.default)(styles('tooltip', tooltipPosition))
    }, _react.default.createElement(_.Text, {
      variant: 'medium'
    }, tooltipMessage)));
  } else if (isInternalLink(onClick)) {
    const children = _react.default.createElement(_react.default.Fragment, null, label, loading && _react.default.createElement(_spinner.default, {
      size: 'small',
      className: styles('spinner')
    }));

    const props = {
      to: onClick.location,
      className: composed_classname
    };
    return _react.default.createElement(onClick.component, props, children);
  } else {
    return _react.default.createElement("a", {
      id: dataTestId,
      "data-testid": dataTestId,
      className: composed_classname,
      href: !disabled ? onClick.location : undefined,
      target: onClick.target || '_blank',
      style: composed_styles,
      ...props
    }, label, loading && _react.default.createElement(_spinner.default, {
      size: 'small',
      className: styles('spinner')
    }));
  }
});
Button.defaultProps = {
  variant: 'contained'
};
var _default = Button;
exports.default = _default;